import * as React from "react"
import {useTranslation} from "react-i18next";
import {useNavigate, useSearchParams, useParams, Link, useLocation} from "react-router-dom";
import {useSnackbar} from "notistack";
import axios from "axios";
import {handleSetQuery} from "../../assets/js/main";
import {setLoading} from "../../redux/loading/actions";
import {useDispatch, useSelector} from "react-redux";
import {Backdrop, CircularProgress} from "@mui/material";
import NavBar from "../../components/NavBar";
import Divider from "@mui/material/Divider";
import {ThemeContext} from "../../App";



export default function Track(){
  const {t} = useTranslation()
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {enqueueSnackbar} = useSnackbar();
  const location = useLocation();
  let { code } = useParams();
  const [listTracking, setListTracking] = React.useState([]);
  const [listInfoTracking, setListInfoTracking] = React.useState([]);
  const theme = React.useContext(ThemeContext)


  React.useEffect(() => {
    const _code = code.split('&')[0]
    handleTracking(_code)

  }, [code])


   const handleTracking = async (e) => {
     dispatch(setLoading(true))
     try {
       let fetch = await axios({
         method: 'GET',
         url: 'https://postex.ir/api/geTracking',
         headers: {},
         params: {
           trackingNumber: e,
           token: '07b44357fb514837bd6afadfa448dece'
         }
       });

       if (fetch?.data?.IsSuccess) {
         const list = fetch?.data?.Data ? JSON.parse(fetch?.data?.Data[0]?.AllState) : []
         setListTracking(fetch?.data?.Data || [])
         setListInfoTracking(list)
       } else {
         enqueueSnackbar(fetch?.data?.Message, {
           variant: 'error',
           TransitionProps: {
             direction: 'down',
           },
           anchorOrigin: {
             horizontal: 'center',
             vertical: 'top'
           }
         })
       }
       dispatch(setLoading(false))

     } catch (e) {
       dispatch(setLoading(false))
       console.log(e)
     }


  }


  return(
     <>
       {selector?.loading?.isLoading &&
       <div className="backdrop-loading">
         <div className="backdrop-bg">
           <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
         </div>
       </div>
       }

       <NavBar/>

       <div className="track-page">
         <div className="container">

           {/*<div className="logo">*/}
           {/*  <NavLink to=''>*/}
           {/*    <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt=""/>*/}
           {/*  </NavLink>*/}
           {/*</div>*/}

           <div className="main-title">
             <p>{t("homeDesktop.s1.t18")}<span>{t("homeDesktop.s1.t19")}</span></p>
             <span>{t("homeDesktop.s1.t20")}<p>{t("homeDesktop.s1.t21")}!</p></span>
           </div>

           <div className="description">
             <p>{t("homeDesktop.s1.t2")}</p>
           </div>

           <Divider className="mb-4"/>

           <div className="row">
             <div className="col-12 col-md-6">
               <div className="itemTracking">
                 <p>{t("homeDesktop.s1.t26")} :</p>
                 <span>{listTracking[0]?.TrackingNumber}</span>
               </div>
             </div>
             <div className="col-12 col-md-6">
               <div className="itemTracking">
                 <p>{t("homeDesktop.s1.t8")} :</p>
                 <span>{listTracking[0]?.NameServiceProvider}</span>
               </div>
             </div>
             <div className="col-12 col-md-6">
               <div className="itemTracking">
                 <p>{t("homeDesktop.s1.t9")} :</p>
                 <span>{listTracking[0]?.ShipmentWeight}</span>
               </div>
             </div>
             <div className="col-12 col-md-6">
               <div className="itemTracking">
                 <p>{t("homeDesktop.s1.t10")} :</p>
                 <span>{listTracking[0]?.DataCollect}</span>
               </div>
             </div>
             <div className="col-12 col-md-6">
               <div className="itemTracking">
                 <p>{t("homeDesktop.s1.t11")} :</p>
                 <span>{listTracking[0]?.ShippedDate}</span>
               </div>
             </div>
             <div className="col-12 col-md-6">
               <div className="itemTracking">
                 <p>{t("homeDesktop.s1.t12")} :</p>
                 <span>{listTracking[0]?.DeliveryDate}</span>
               </div>
             </div>
             <div className="col-12 col-md-6">
               <div className="itemTracking">
                 <p>{t("homeDesktop.s1.t13")} :</p>
                 <span>{listTracking[0]?.SenderFullName}</span>
               </div>
             </div>
             <div className="col-12 col-md-6">
               <div className="itemTracking">
                 <p>{t("homeDesktop.s1.t14")} :</p>
                 <span>{listTracking[0]?.SenderAddress}</span>
               </div>
             </div>
             <div className="col-12 col-md-6">
               <div className="itemTracking">
                 <p>{t("homeDesktop.s1.t15")} :</p>
                 <span>{listTracking[0]?.ReceiverFullName}</span>
               </div>
             </div>
             <div className="col-12 col-md-6">
               <div className="itemTracking">
                 <p>{t("homeDesktop.s1.t16")} :</p>
                 <span>{listTracking[0]?.ReceiverAddress}</span>
               </div>
             </div>
           </div>


           <div className="row mb-5">
             {
               listInfoTracking?.map((item, index) => {
                 return (
                    <div className="col-12">
                      <div className="itemTracking">
                        <span>{index + 1}</span>
                        <div>
                          {
                            item?.desc.split('،').map(item2 => <p>{item2}</p>)
                          }
                        </div>
                        <span>{item?.date}</span>
                      </div>
                    </div>
                 )
               })
             }
           </div>


           <div className="row">
             <div className="col-12 col-md-6 mb-3">
               <div className="btnGroup_yellow m-0">
                 <Link to={{pathname: '/singleOrder', search: location?.search}}
                       type="button" className="btnFill justify-content-center" id="singleOrder">{t("homeMobile.t30")}</Link>
               </div>

             </div>

             <div className="col-12 col-md-6 mb-3">
               <div className="btnGroup_light m-0">
                 <Link to={{pathname: '/tracking', search: location?.search}} type="button" className="btnEmpty w-100 justify-content-center w-100" id="tracking">{t("homeMobile.t1")}</Link>
               </div>
             </div>
           </div>

         </div>
       </div>
     </>
  )
}
